import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col-reverse sm:flex-row md:flex-col-reverse lg:flex-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "sr-only" }, "Street listings", -1)
const _hoisted_3 = { class: "w-full sm:w-1/3 md:w-full lg:w-1/3 xl:w-1/4 h-full sm:h-(screen-16) md:h-full lg:h-(screen-16) overflow-y-auto" }
const _hoisted_4 = {
  key: 0,
  class: "p-4 grid grid-cols-1 gap-3"
}
const _hoisted_5 = { class: "p-2 grid grid-cols-1 gap-1" }
const _hoisted_6 = ["id", "for"]
const _hoisted_7 = ["id", "for"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_10 = {
  key: 1,
  class: "p-4 grid grid-cols-1 gap-3"
}
const _hoisted_11 = {
  key: 0,
  class: "p-2 border border-black rounded-md shadow bg-white overflow-auto flex flex-col"
}
const _hoisted_12 = { class: "font-semibold text-lg" }
const _hoisted_13 = { class: "text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_address_suggest = _resolveComponent("address-suggest")!
  const _component_Candidate = _resolveComponent("Candidate")!
  const _component_CandidateList = _resolveComponent("CandidateList")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Section = _resolveComponent("Section")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Full = _resolveComponent("Full")!
  const _component_MapVue = _resolveComponent("MapVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      (!_ctx.street)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createVNode(_component_address_suggest, { onSearch: _ctx.handleSearch }, null, 8, ["onSearch"]),
            _createVNode(_component_CandidateList, { open: _ctx.showCandidates }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (c, index) => {
                  return (_openBlock(), _createBlock(_component_Candidate, {
                    key: index,
                    candidate: c,
                    class: "my-1 border rounded-lg shadow",
                    onClick: ($event: any) => (_ctx.handleSelect(c)),
                    onKeyup: [
                      _withKeys(($event: any) => (_ctx.handleSelect(c)), ["enter"]),
                      _withKeys(($event: any) => (_ctx.handleSelect(c)), ["space"])
                    ]
                  }, null, 8, ["candidate", "onClick", "onKeyup"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_component_Panel, {
              icon: "cog",
              color: "gray",
              variant: "light",
              open: _ctx.open,
              name: "Settings",
              onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
            }, {
              default: _withCtx(() => [
                _createElementVNode("fieldset", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classifications, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: c.value,
                      class: "flex items-center space-x-1"
                    }, [
                      _createVNode(_component_Toggle, {
                        id: `classification-${c.value.toLowerCase()}`,
                        name: `classification-${c.value.toLowerCase()}`,
                        label: c.label,
                        modelValue: c.enabled,
                        class: "text-xs",
                        "onUpdate:modelValue": ($event: any) => (_ctx.handleClassificationToggle(c))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("label", {
                            id: `classification-${c.value.toLowerCase()}-label`,
                            for: `classification-${c.value.toLowerCase()}`,
                            class: "inline-flex items-center space-x-1"
                          }, [
                            _createElementVNode("i", {
                              class: "w-5 h-5 border border-current rounded",
                              style: _normalizeStyle({ 'background-color': c.symbol.value.formatRgb() })
                            }, null, 4),
                            _createElementVNode("span", null, _toDisplayString(c.label), 1)
                          ], 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1032, ["id", "name", "label", "modelValue", "onUpdate:modelValue"])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (d) => {
                    return (_openBlock(), _createBlock(_component_Toggle, {
                      id: `district-${d.value.toLowerCase()}`,
                      name: `district-${d.value.toLowerCase()}`,
                      key: d.value,
                      label: d.label,
                      modelValue: d.enabled,
                      "onUpdate:modelValue": ($event: any) => (_ctx.handleClassificationToggle(d)),
                      class: "text-xs"
                    }, {
                      default: _withCtx(() => [
                        (d.symbol.type == 'image')
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              id: `district-${d.value.toLowerCase()}-label`,
                              for: `district-${d.value.toLowerCase()}`,
                              class: "inline-flex items-center space-x-1"
                            }, [
                              _createElementVNode("img", {
                                class: "w-5 h-5 border border-current rounded",
                                src: `data:${d.symbol.mime};base64,${d.symbol.value}`
                              }, null, 8, _hoisted_8),
                              _createElementVNode("span", null, _toDisplayString(d.label), 1)
                            ], 8, _hoisted_7))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["id", "name", "label", "modelValue", "onUpdate:modelValue"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["open"]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform scale-y-95",
              "enter-to-class": "transform scale-y-100",
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "transform scale-y-100",
              "leave-to-class": "transform scale-y-95"
            }, {
              default: _withCtx(() => [
                (_ctx.message)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      color: _ctx.message.type == 'Info' ? 'blue' : 'red',
                      variant: "light",
                      icon: _ctx.message.type == 'Info' ? 'information' : 'exclamation'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.message.message), 1)
                      ]),
                      _: 1
                    }, 8, ["color", "icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.streets, (street) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: street.hash
                }, [
                  _createVNode(_component_Section, {
                    street: street,
                    onHighlightSection: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.highlightStreet({ type: 'section', data: $event })
              )),
                    onHighlightSegment: _cache[2] || (_cache[2] = ($event: any) => (
                _ctx.highlightStreet({ type: 'segment', data: $event })
              ))
                  }, null, 8, ["street"])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_10, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: {
              name: 'Streets',
              query: {
                extent: [
                  _ctx.extent.xmin,
                  _ctx.extent.ymin,
                  _ctx.extent.xmax,
                  _ctx.extent.ymax,
                ].join(','),
              },
            },
                class: "inline-flex border-b-2 border-current"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Back to search")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform scale-y-95",
              "enter-to-class": "transform scale-y-100",
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "transform scale-y-100",
              "leave-to-class": "transform scale-y-95"
            }, {
              default: _withCtx(() => [
                (_ctx.message)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      color: _ctx.message.type == 'Info' ? 'blue' : 'red',
                      variant: "light",
                      icon: _ctx.message.type == 'Info' ? 'information' : 'exclamation'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.message.message), 1)
                      ]),
                      _: 1
                    }, 8, ["color", "icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Full, { street: _ctx.street }, null, 8, ["street"])
          ]))
    ]),
    _createVNode(_component_MapVue, {
      id: "streets",
      map: _ctx.map,
      extent: _ctx.extent,
      center: _ctx.center,
      zoom: _ctx.zoom,
      options: {
        highlightOptions: {
          color: '#FF9494',
          fillOpacity: 0.8,
          haloColor: '#E65C5C',
          haloOpacity: 1,
        },
      },
      class: "w-full sm:w-2/3 md:w-full lg:w-2/3 xl:w-3/4 h-screen-50 sm:h-(screen-16) md:h-screen-50 lg:h-(screen-16) overflow-y-auto",
      onZoomChange: _ctx.handleZoom,
      onExtentChange: _ctx.handleExtent,
      onClickHit: _ctx.handleClick,
      onLayerView: _ctx.handleLayerView,
      onPointerHit: _ctx.handlePointer
    }, {
      "top-right": _withCtx(() => [
        (_ctx.pointer)
          ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pointer.name), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.label(_ctx.pointer.classifications?.design)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      "bottom-right": _withCtx(() => []),
      _: 1
    }, 8, ["map", "extent", "center", "zoom", "onZoomChange", "onExtentChange", "onClickHit", "onLayerView", "onPointerHit"])
  ]))
}